// extracted by mini-css-extract-plugin
module.exports = {"modalRoot":"az_GCb","disableScrollBar":"az_HCb","modalTooltip":"az_ICb"};